/* eslint-disable no-confusing-arrow */
import { Component, Host, h, Prop, Element, State, Watch, Build } from '@stencil/core';
import { AppService, DomService } from '../../services';
import { TrackingService } from '../../services/tracking';
import { TrackingObjectBuilder } from '../../services/tracking/tracking-object-builder';
import { ButtonAppearance } from '../rcm-button/rcm-button.types';

@Component({
  tag: 'rcm-layout-container',
  styleUrl: 'rcm-layout-container.scss',
  shadow: true,
})
export class RcmLayoutContainer {
  @Prop() kind: string;

  @Prop() isArticle?: boolean;

  @Prop() currenttype: string;

  @Prop() hasProminentCampaign: boolean;

  @Prop() hasBasicCampaign: boolean;

  @Element() el: HTMLElement;

  @State() showAussetzung = false;

  @State() alreadyShown = false;

  @Watch('showAussetzung')
  componentDidLoad() {
    if (!this.isArticle) {
      const targetNodes = ['rcm-richtext', 'rcm-headline', 'rcm-editorial-section-header'];
      const room = targetNodes.includes(
        // eslint-disable-next-line comma-dangle
        this.el.children[0]?.children[0]?.localName,
      );
      if (room) {
        this.el.classList.add('padded');
      }
    }
    const sectionHash = window.location.hash;
    if (sectionHash) {
      try {
        document.getElementById(sectionHash.replace('#', '')).scrollIntoView();
      } catch (error) {
        console.error(error);
      }
    }
  }

  componentWillLoad() {
    const href = window.location.href.toLowerCase();
    const pathname = href.charAt(href.length - 1) === '/' ? new URL(href).pathname : `${new URL(href).pathname}/`;
    const { fondpreisaussetzung } = DomService.getGlobalContent();
    const funds = fondpreisaussetzung?.mandatoryFonds?.toLowerCase().split(',');
    const forcePages = fondpreisaussetzung?.mandatoryPages?.split(',').map((page) => (page.charAt(page.length - 1) === '/' ? page : `${page}/`));
    const forceShowAgain = forcePages?.includes(pathname) || funds?.filter((fund) => pathname.includes(fund)).length > 0;
    const aussetzung = window.sessionStorage.getItem('aussetzung');
    this.alreadyShown = aussetzung && !forceShowAgain;

    if (Build.isBrowser) {
      const { country, locale } = DomService.getGlobalConfig();

      TrackingService.push(
        new TrackingObjectBuilder()
          .forPageContext({
            userType: AppService.getUserType(),
            country,
            language: locale,
          })
          .build(),
      );
    }
  }

  render() {
    return (
      <Host class={`${this.el.dataset.salzburg === 'true' || this.el.dataset.golfmeisterschaft === 'true' ? 'custom-container' : ''}`}>
        <div class={`${this.kind} ${this.el.dataset.salzburg === 'true' || this.el.dataset.golfmeisterschaft === 'true' ? 'custom' : ''}`}>
          {this.hasProminentCampaign && <rcm-campaign-banner></rcm-campaign-banner>}
          {this.hasBasicCampaign && <rcm-campaign-banner-basic></rcm-campaign-banner-basic>}
          {this.renderFondpreisaussetzung()}
          <slot name="content"></slot>
        </div>
      </Host>
    );
  }

  renderFondpreisaussetzung() {
    const { fondpreisaussetzung } = DomService.getGlobalContent();
    /**
     * If fonds are listed, we assume an active ausetzung
     */
    if (fondpreisaussetzung?.aktiv === 'ja') {
      const { pageType, mandatoryPages } = fondpreisaussetzung;
      const manPages = mandatoryPages.split(',');
      // eslint-disable-next-line no-restricted-globals
      const needsToBeShown = manPages.filter((m) => location.pathname.includes(m)).length > 0;
      if (pageType === 'global' || needsToBeShown || pageType.includes(this.currenttype)) {
        this.showAussetzung = true;
        if (!this.alreadyShown) {
          return (
            <rcm-container fullWidth class="aussetzung-container">
              <rcm-container>
                <span
                  class="close-aussetzung"
                  onClick={() => {
                    this.alreadyShown = true;
                    this.showAussetzung = false;
                    document.querySelector('rcm-layout-container')?.classList.add('padded');

                    window.sessionStorage.setItem('aussetzung', 'true');
                  }}
                >
                  x
                </span>
                <rcm-column>
                  <rcm-headline headline={fondpreisaussetzung.headline} level={4} bold />
                  <p>
                    {fondpreisaussetzung.contentTop} <b>{fondpreisaussetzung.fonds.split(',').join(', ')}</b>
                    <br />
                    {fondpreisaussetzung.contentBottom}
                  </p>
                  {fondpreisaussetzung.linkText && (
                    <rcm-button
                      text={fondpreisaussetzung.linkText}
                      link={fondpreisaussetzung.linkTarget}
                      appearance={ButtonAppearance.TERTIARY}
                    ></rcm-button>
                  )}
                </rcm-column>
              </rcm-container>
            </rcm-container>
          );
        }
      }
    }
    return null;
  }
}
